import { render, staticRenderFns } from "./DashboardGeneralReports.vue?vue&type=template&id=7a1a47ce"
import script from "./DashboardGeneralReports.vue?vue&type=script&lang=js"
export * from "./DashboardGeneralReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports